import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Target, Sparkles } from 'lucide-react';
export function About() {
  return <section id="about" className="py-24 bg-midnight text-ivory overflow-hidden relative" data-id="element-32" data-mp="2ps0eiesh2rnl">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-midnight-light to-transparent opacity-50 pointer-events-none" data-id="element-33" data-mp="2yrwvdu8mem83" />

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-34" data-mp="33qqbzvj7etch">
        <div className="grid lg:grid-cols-12 gap-6" data-id="element-35" data-mp="38ptaex4oi1bh">
          {/* Vision Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="lg:col-span-8 bg-gold text-midnight rounded-[2rem] p-8 md:p-12 relative overflow-hidden group" data-id="element-36" data-mp="3dhb91ej8bpta">
            <div className="absolute -right-20 -top-20 w-64 h-64 bg-white/20 rounded-full blur-3xl group-hover:scale-150 transition-transform duration-700" data-id="element-37" data-mp="2lr7ii6i4g62y" />

            <div className="flex items-center justify-between mb-12 relative z-10" data-id="element-38" data-mp="2gqkvmr0u7gr3">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-midnight text-ivory rounded-full text-xs font-bold tracking-widest uppercase" data-id="element-39" data-mp="2crc13jxz3euh">
                <Target className="w-4 h-4 text-gold" data-id="element-40" data-mp="34hp4ztcd25fv" />
                Vision
              </div>
              <span className="text-5xl font-display font-black opacity-20" data-id="element-41" data-mp="30g3lhp5bmswp">
                01
              </span>
            </div>

            <h3 className="text-4xl md:text-6xl font-display font-bold leading-[1.1] tracking-tight relative z-10" data-id="element-42" data-mp="2vod79839jl00">
              Raising Global <br data-id="element-43" data-mp="2qq1zd2wj3kkf" />
              <span className="font-serif italic font-medium" data-id="element-44" data-mp="2qohde1oa59y6">
                Endtime Armies
              </span>{' '}
              <br data-id="element-45" data-mp="3jf96urdynkht" />
              for the Body of Christ.
            </h3>
          </motion.div>

          {/* Mission Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="lg:col-span-4 bg-ivory text-midnight rounded-[2rem] p-8 md:p-10 flex flex-col justify-between" data-id="element-46" data-mp="66vdp073fr51">
            <div className="flex items-center justify-between mb-8" data-id="element-47" data-mp="3ojtj3mmnnc6l">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-midnight/5 rounded-full text-xs font-bold tracking-widest uppercase" data-id="element-48" data-mp="3ol4mvmg3ojxp">
                <BookOpen className="w-4 h-4 text-gold" data-id="element-49" data-mp="3el3xbirn17l2" />
                Mission
              </div>
              <span className="text-4xl font-display font-black text-midnight/10" data-id="element-50" data-mp="18s5nbujdnppd">
                02
              </span>
            </div>

            <p className="text-xl md:text-2xl font-medium leading-snug tracking-tight" data-id="element-51" data-mp="1ctqvj2kyvft8">
              Raising Kingdom Giants through the study of God's word, prayer
              meetings, outreaches, retreats, camp meetings, missions, and
              evangelism.
            </p>
          </motion.div>

          {/* Night Watchers Card */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="lg:col-span-12 bg-white/5 border border-white/10 rounded-[2rem] p-8 md:p-16 relative overflow-hidden backdrop-blur-sm" data-id="element-52" data-mp="32be85yru9b6h">
            <div className="absolute top-1/2 right-10 -translate-y-1/2 opacity-10 pointer-events-none hidden md:block" data-id="element-53" data-mp="3l02t2kqbngi9">
              <Sparkles className="w-64 h-64 text-gold" data-id="element-54" data-mp="1qo4juis0ikmd" />
            </div>

            <div className="max-w-3xl relative z-10" data-id="element-55" data-mp="1qq8vxo02epxq">
              <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/10 rounded-full text-xs font-bold tracking-widest uppercase mb-8 text-gold" data-id="element-56" data-mp="1t1huxd7x7ayt">
                Identity
              </div>

              <h2 className="text-5xl md:text-7xl font-display font-bold tracking-tighter mb-8" data-id="element-57" data-mp="224iyb65einys">
                The Night{' '}
                <span className="font-serif italic font-medium text-gold" data-id="element-58" data-mp="27081djgmqmzu">
                  Watchers
                </span>
              </h2>

              <div className="grid md:grid-cols-2 gap-8 text-lg md:text-xl text-ivory/80 font-medium leading-relaxed" data-id="element-59" data-mp="1ed3sv4ibvqjb">
                <p data-id="element-60" data-mp="1jborizhxm25n">
                  We are called to stand in the gap. Like the watchmen on the
                  walls, we do not rest until His purpose is established on the
                  earth.
                </p>
                <p data-id="element-61" data-mp="qnsmn7i7l3xs">
                  Through dedicated intercession and active outreach, we are
                  building a generation equipped for the end-time harvest.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}